export default __webpack_public_path__ + "static/media/animation_point.ecca1a97.gif";